import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import NavbarMob from "../components/NavbarMob";
import Navbar from "../components/Navbar";
import Navbar2 from "../components/Navbar2";
import Navbar2Mob from "../components/Navbar2Mob";
import Footer from "../components/Footer";
import { useMediaQuery } from "react-responsive";
import qrcode from "../images/payment/qrcode.jpeg";

const PaymentQR = () => {
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Data passed from Packages page
    const { planName, amount, employeeId } = location.state || {};

    if (!employeeId) {
        return (
            <div className="min-h-screen flex flex-col items-center justify-center">
                <p className="text-red-600 text-xl">No payment details found. Please try again.</p>
                <button onClick={() => navigate("/packages")} className="mt-4 px-6 py-3 bg-[#E22E37] text-white rounded-lg">
                    Back to Packages
                </button>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex flex-col">
            {isMobile ? <NavbarMob /> : <Navbar />}
            <div className="md:flex hidden">
                <Navbar2 />
            </div>
            <div className="md:hidden flex flex-col">
                <Navbar2Mob />
            </div>

            <div className="flex-1 flex flex-col items-center justify-center py-12 px-4 gap-8">
                <div className="text-center max-w-2xl">
                    <h1 className="text-3xl md:text-4xl font-bold font-display text-[#E22E37] mb-4">
                        Complete Your Payment
                    </h1>
                    <p className="text-lg font-semibold text-gray-600 mb-3">
                        Candidate ID: <strong>{employeeId}</strong>
                    </p>
                    <p className="text-lg text-gray-700 mb-2">
                        You've selected the <strong>{planName}</strong> plan .
                    </p>
                    <p className="text-lg text-gray-700">
                        Please make the payment <strong>₹{amount}</strong>.
                    </p>
                </div>

                <div className="bg-white p-8 rounded-xl shadow-2xl">
                    <p className="text-center text-lg font-medium mb-6">Scan the QR code to pay via UPI</p>
                    <div className="flex justify-center">
                        <img
                            src={qrcode}
                            alt="Payment QR Code"
                            className="w-64 h-64 md:w-80 md:h-80 object-contain rounded-lg"
                        />
                    </div>
                    <p className="text-center text-lg text-gray-500 mt-6">
                        After payment, <strong> send the screenshot to us in the number given below,</strong> <br /> our
                        team will activate your plan within 24 hours.
                    </p>
                    <p className="text-center text-lg text-gray-500 mt-6">
                        <strong> ( പേയ്‌മെന്റ് ന് ശേഷം താഴെ കൊടുത്തിരിക്കുന്ന നമ്പറിൽ സ്ക്രീൻഷോട്ട് അയക്കുക. )</strong>
                    </p>
                </div>

                <div className="text-center">
                    <p className="text-gray-600">
                        Having trouble? Contact us on WhatsApp:{" "}
                        <a href="https://wa.me/917356400746" className="text-green-600 font-bold">
                            +91 7356 400 746
                        </a>
                    </p>
                    <button
                        onClick={() => navigate("/")}
                        className="mt-6 px-8 py-3 bg-[#E22E37] text-white rounded-full text-lg font-semibold hover:bg-black transition"
                    >
                        Back to Home
                    </button>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default PaymentQR;
